import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function NewsletterEditor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [newsletter, setNewsletter] = useState({
    title: '',
    subject: '',
    cover_image: '',
    featured_image: '',
    hero_text: '',
    hero_link: ''
  });
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      loadNewsletter();
    }
  }, [id]);

  const loadNewsletter = async () => {
    try {
      const response = await fetch(`/api/newsletters/${id}`);
      const data = await response.json();
      setNewsletter(data.newsletter);
      setSections(data.sections);
    } catch (error) {
      console.error('Error loading newsletter:', error);
    }
  };

  const handleNewsletterChange = (field, value) => {
    setNewsletter({ ...newsletter, [field]: value });
  };

  const saveNewsletter = async () => {
    setLoading(true);
    try {
      const url = id 
        ? `/api/admin/newsletters/${id}` 
        : '/api/admin/newsletters';
      const method = id ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newsletter)
      });
      
      const data = await response.json();
      if (id) {
        window.location.href = `/admin/newsletters/${data.id}`;
//        navigate(`/admin/newsletters/${data.id}`);
      }
      alert('Newsletter saved!');
    } catch (error) {
      alert('Error saving newsletter');
    }
    setLoading(false);
  };

  const addSection = async (sectionType) => {
    const newSection = {
      section_type: sectionType,
      title: '',
      content: '',
      image_url: '',
      link_url: '',
      order_index: sections.length
    };

    try {
      const response = await fetch(`/api/admin/newsletters/${id}/sections`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newSection)
      });
      const data = await response.json();
      setSections([...sections, data]);
    } catch (error) {
      alert('Error adding section');
    }
  };

  const updateSection = async (sectionId, updates) => {
    try {
      const response = await fetch(`/api/admin/sections/${sectionId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      const data = await response.json();
      setSections(sections.map(s => s.id === sectionId ? data : s));
    } catch (error) {
      alert('Error updating section');
    }
  };

  const deleteSection = async (sectionId) => {
    if (!window.confirm('Delete this section?')) return;
    
    try {
      await fetch(`/api/admin/sections/${sectionId}`, { method: 'DELETE' });
      setSections(sections.filter(s => s.id !== sectionId));
    } catch (error) {
      alert('Error deleting section');
    }
  };

  const sendNewsletter = async () => {
    if (!window.confirm('Send this newsletter to all subscribers?')) return;
    
    setLoading(true);
    try {
      const response = await fetch(`/api/admin/newsletters/${id}/send`, {
        method: 'POST'
      });
      const data = await response.json();
      alert(data.message);
      window.location.href = '/admin/newsletters';        
//      navigate('/admin/newsletters');
    } catch (error) {
      alert('Error sending newsletter');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1>Newsletter Editor</h1>
      
      {/* Newsletter Settings */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '24px', borderRadius: '8px', marginBottom: '32px' }}>
        <h2>Newsletter Settings</h2>
        
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Title
          </label>
          <input
            type="text"
            value={newsletter.title}
            onChange={(e) => handleNewsletterChange('title', e.target.value)}
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Email Subject Line
          </label>
          <input
            type="text"
            value={newsletter.subject}
            onChange={(e) => handleNewsletterChange('subject', e.target.value)}
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Cover Image URL
          </label>
          <input
            type="text"
            value={newsletter.cover_image}
            onChange={(e) => handleNewsletterChange('cover_image', e.target.value)}
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Featured Image URL
          </label>
          <input
            type="text"
            value={newsletter.featured_image}
            onChange={(e) => handleNewsletterChange('featured_image', e.target.value)}
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Hero Text
          </label>
          <textarea
            value={newsletter.hero_text}
            onChange={(e) => handleNewsletterChange('hero_text', e.target.value)}
            rows="4"
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Hero Link URL (optional)
          </label>
          <input
            type="text"
            value={newsletter.hero_link}
            onChange={(e) => handleNewsletterChange('hero_link', e.target.value)}
            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
          />
        </div>

        <button
          onClick={saveNewsletter}
          disabled={loading}
          style={{
            backgroundColor: '#000',
            color: '#fff',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          {loading ? 'Saving...' : 'Save Newsletter'}
        </button>
      </div>

      {/* Sections */}
      {id && (
        <div>
          <h2>Content Sections</h2>
          
          <div style={{ marginBottom: '24px' }}>
            <button onClick={() => addSection('heading')} style={buttonStyle}>+ Heading</button>
            <button onClick={() => addSection('text')} style={buttonStyle}>+ Text</button>
            <button onClick={() => addSection('image')} style={buttonStyle}>+ Image</button>
            <button onClick={() => addSection('list')} style={buttonStyle}>+ List</button>
            <button onClick={() => addSection('highlight')} style={buttonStyle}>+ Highlight Box</button>
            <button onClick={() => addSection('product')} style={buttonStyle}>+ Product</button>
          </div>

          {sections.map((section, index) => (
            <SectionEditor
              key={section.id}
              section={section}
              onUpdate={updateSection}
              onDelete={deleteSection}
            />
          ))}

          {sections.length > 0 && (
            <div style={{ marginTop: '32px', padding: '24px', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
              <h3>Ready to Send?</h3>
              <p>This will send the newsletter to all subscribers immediately.</p>
              <button
                onClick={sendNewsletter}
                disabled={loading}
                style={{
                  backgroundColor: '#28a745',
                  color: '#fff',
                  padding: '12px 32px',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                {loading ? 'Sending...' : 'Send Newsletter to All Subscribers'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function SectionEditor({ section, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState(section);

  const handleSave = () => {
    onUpdate(section.id, formData);
    setEditing(false);
  };

  if (!editing) {
    return (
      <div style={{ 
        border: '1px solid #ddd', 
        padding: '16px', 
        marginBottom: '16px', 
        borderRadius: '8px',
        backgroundColor: '#fff'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>{section.section_type}</strong>
            {section.title && <span> - {section.title}</span>}
          </div>
          <div>
            <button onClick={() => setEditing(true)} style={smallButtonStyle}>Edit</button>
            <button onClick={() => onDelete(section.id)} style={{...smallButtonStyle, backgroundColor: '#dc3545'}}>Delete</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      border: '2px solid #007bff', 
      padding: '24px', 
      marginBottom: '16px', 
      borderRadius: '8px',
      backgroundColor: '#f8f9fa'
    }}>
      <h4>{section.section_type.toUpperCase()}</h4>
      
      {['heading', 'product'].includes(section.section_type) && (
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Title</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
      )}

      {['text', 'list', 'highlight', 'product'].includes(section.section_type) && (
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
            Content {section.section_type === 'list' && '(one item per line)'}
          </label>
          <textarea
            value={formData.content}
            onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            rows="4"
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
      )}

      {['image', 'product'].includes(section.section_type) && (
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Image URL</label>
          <input
            type="text"
            value={formData.image_url}
            onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
      )}

      {section.section_type === 'product' && (
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Link URL</label>
          <input
            type="text"
            value={formData.link_url}
            onChange={(e) => setFormData({ ...formData, link_url: e.target.value })}
            style={{ width: '100%', padding: '8px' }}
          />
        </div>
      )}

      <div>
        <button onClick={handleSave} style={smallButtonStyle}>Save</button>
        <button onClick={() => setEditing(false)} style={{...smallButtonStyle, backgroundColor: '#6c757d'}}>
          Cancel
        </button>
      </div>
    </div>
  );
}

const buttonStyle = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '8px 16px',
  border: 'none',
  borderRadius: '4px',
  marginRight: '8px',
  cursor: 'pointer'
};

const smallButtonStyle = {
  padding: '6px 12px',
  marginRight: '8px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  backgroundColor: '#007bff',
  color: '#fff'
};